import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core'
import { OptionsNgxOwCarouselService } from 'dmmp-services'

@Component({
  selector: 'dmmp-banner-content-desktop',
  templateUrl: './banner-content-desktop.component.html'
})
export class BannerContentDesktopComponent implements OnInit {

  @Input() module
  @Input() configCarousel

  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  constructor(private options: OptionsNgxOwCarouselService) { }

  ngOnInit(): void {
    this.configCarousel = this.options.configurationBenefits(this.module)
  }

}
